"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addPost;

var _router = require("@reach/router");

var _lodash = require("lodash");

var _immer = _interopRequireDefault(require("immer"));

var _actions = require("../actions");

var _generateSlug = _interopRequireDefault(require("./generateSlug")); // import app components


function addPost(_x, _x2, _x3) {
  return _addPost.apply(this, arguments);
}

function _addPost() {
  _addPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, dispatch, config) {
    var site, postTypeID, title, parentID, result, _site$postTypes, postType, nextPostType, slug;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            site = _ref.site, postTypeID = _ref.postTypeID, title = _ref.title, parentID = _ref.parentID;
            _context.next = 3;
            return _actions.postActions.addPost({
              siteID: site.id,
              postTypeID: postTypeID,
              status: 'draft',
              title: title,
              parentID: parentID
            }, dispatch, config);

          case 3:
            result = _context.sent;

            if (result !== null && result !== void 0 && result.id) {
              postType = site === null || site === void 0 ? void 0 : (_site$postTypes = site.postTypes) === null || _site$postTypes === void 0 ? void 0 : _site$postTypes[postTypeID]; // Add post to post type so we can then generate the slug and the route the newly created post

              nextPostType = (0, _immer.default)(postType, function (draft) {
                return (0, _lodash.set)(draft, "posts.".concat(result.id), result);
              });
              slug = (0, _generateSlug.default)(nextPostType, result.id, site === null || site === void 0 ? void 0 : site.frontPage);
              (0, _router.navigate)("/".concat(slug));
            }

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _addPost.apply(this, arguments);
}